export const FETCH_EPG_LINE_UP_INIT = 'FETCH_EPG_LINE_UP_INIT';
export const FETCH_EPG_LINE_UP_SUCCESS = 'FETCH_EPG_LINE_UP_SUCCESS';
export const FETCH_EPG_LINE_UP_ERROR = 'FETCH_EPG_LINE_UP_ERROR';
